"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enumValues = exports.enumKeys = exports.enumObject = exports.InvertEnum = exports.getKeyFromValue = exports.Permissoes = void 0;
__exportStar(require("./adapta"), exports);
__exportStar(require("./avaliac"), exports);
__exportStar(require("./aluno"), exports);
__exportStar(require("./alunoLogin"), exports);
__exportStar(require("./app"), exports);
__exportStar(require("./chat"), exports);
__exportStar(require("./cliente"), exports);
__exportStar(require("./configOnline"), exports);
__exportStar(require("./curso"), exports);
__exportStar(require("./dias"), exports);
__exportStar(require("./dicionar"), exports);
__exportStar(require("./escolaridade"), exports);
__exportStar(require("./estadoCivil"), exports);
__exportStar(require("./financeiro"), exports);
__exportStar(require("./materia"), exports);
__exportStar(require("./mensagem"), exports);
__exportStar(require("./notification"), exports);
__exportStar(require("./ocorrencia"), exports);
exports.Permissoes = __importStar(require("./permissoes"));
__exportStar(require("./permissoes2"), exports);
__exportStar(require("./profissoes"), exports);
__exportStar(require("./questionario"), exports);
__exportStar(require("./raca"), exports);
__exportStar(require("./sexo"), exports);
__exportStar(require("./serie"), exports);
__exportStar(require("./situacaoMatricula"), exports);
__exportStar(require("./tipoSanguineo"), exports);
__exportStar(require("./turno"), exports);
__exportStar(require("./visita"), exports);
__exportStar(require("./sistemaAvaliacao"), exports);
__exportStar(require("./usuario"), exports);
__exportStar(require("./fintech"), exports);
__exportStar(require("./conta"), exports);
__exportStar(require("./tipoDispensa"), exports);
const getKeyFromValue = (xpto, value) => {
    const key = Object.entries(xpto).filter((item) => item[1].trim() === value.trim());
    if (key && key[0] && key[0][0])
        return key[0][0];
    return '';
};
exports.getKeyFromValue = getKeyFromValue;
const InvertEnum = (coitado) => {
    const list = Object.entries(coitado);
    const novo = {};
    for (const cada of list) {
        const [key, value] = cada;
        novo[value] = key;
    }
    return novo;
};
exports.InvertEnum = InvertEnum;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const enumObject = (e) => {
    const copy = Object.assign({}, e);
    Object.values(e).forEach((value) => typeof value === 'number' && delete copy[value]);
    return copy;
};
exports.enumObject = enumObject;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const enumKeys = (e) => {
    return Object.keys((0, exports.enumObject)(e));
};
exports.enumKeys = enumKeys;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const enumValues = (e) => {
    return [...new Set(Object.values((0, exports.enumObject)(e)))];
};
exports.enumValues = enumValues;
